import React from 'react';
import { Box } from '@mui/material';
import {
  ArrowLeftIcon,
  FolderPlusIcon,
  PlusIcon,
  ClipboardDocumentListIcon,
} from '@heroicons/react/24/outline';
import ButtonComponent from '../customButton';
import ChipComponent from '../chips/ChipComponent/ChipComponent';
import {
  TEST_CASE_EMPTY_CONTENT,
  TEST_CASE_EMPTY_VARIANTS,
} from './testCaseEmptyScreen.constants';
import styles from '../../styles/testCase/testCaseEmptyScreen.module.scss';

const TestCaseEmptyScreen = ({
  variant,
  onAddTestCase,
  title,
  description,
  moduleName,
}) => {
  const isNoModule = variant === TEST_CASE_EMPTY_VARIANTS.NO_MODULE;
  const isNoTestCase = variant === TEST_CASE_EMPTY_VARIANTS.NO_TEST_CASE;
  const isSelectModule = variant === TEST_CASE_EMPTY_VARIANTS.SELECT_MODULE;
  const content = TEST_CASE_EMPTY_CONTENT[variant] || TEST_CASE_EMPTY_CONTENT[TEST_CASE_EMPTY_VARIANTS.NO_MODULE];

  const resolvedTitle = title ?? content.title;
  const resolvedDescription = description ?? (
    typeof content.description === 'function'
      ? content.description(moduleName)
      : content.description
  );

  const handleAddTestCaseClick = () => {
    if (typeof onAddTestCase === 'function') {
      onAddTestCase();
    }
  };

  const variantClassName = isNoModule
    ? styles.variantNoModule
    : isNoTestCase
      ? styles.variantNoTestCase
      : isSelectModule
        ? styles.variantSelectModule
        : '';

  return (
    <Box className={`${styles.container} ${variantClassName}`}>
      <Box className={styles.iconSection}>
      {isNoModule || isSelectModule ? (
        <FolderPlusIcon className={styles.icon} />
      ) : (
        <ClipboardDocumentListIcon className={styles.icon} />
      )}
      </Box>

      <h3 className={styles.title}>{resolvedTitle}</h3>
      <p className={styles.description}>{resolvedDescription}</p>

      {isNoModule && (
        <Box className={styles.leftHint}>
          <ChipComponent
            variant="blue"
            size="small"
            showTooltip={false}
            icon={<ArrowLeftIcon className="icon" />}
            className={styles.hintChip}
          >
            {content.hint}
          </ChipComponent>
        </Box>
      )}

      {isNoTestCase && (
        <>
          <Box className={styles.primaryActionSection}>
            <ButtonComponent
              ctaText={content.buttonLabel}
              variant="primary"
              className="white bg-blue600"
              startIcon={<PlusIcon className="icon" />}
              onClick={handleAddTestCaseClick}
              disabled={typeof onAddTestCase !== 'function'}
              size="small"
            />
          </Box>
          {content.importHint && (
            <p className={styles.importHint}>{content.importHint}</p>
          )}
        </>
      )}
    </Box>
  );
};

export default TestCaseEmptyScreen;
